import {
  IDictionary,
  ILabelOptionValue,
  IOption,
  ITemplate,
} from "../../typings";
import DownloadController from "./download-controller";
import { IStorageController } from "./storage/istorage-controller";

export default class TemplateController {
  storageController: IStorageController;

  constructor(storageController: IStorageController) {
    this.storageController = storageController;
  }

  downloadTemplate(url: string): Promise<ITemplate> {
    return new Promise((resolve: Function, reject: Function) => {
      DownloadController.download(url)
        .then((template: ITemplate) => {
          resolve(template);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("Uploader: Cant load template");
          reject();
        });
    });
  }

  saveTemplate(template: ITemplate): void {
    return this.storageController.saveTemplate(template);
  }

  getTemplate(): ITemplate {
    return this.storageController.getTemplate();
  }

  parseTemplate(template: ITemplate): ITemplate {
    template = this.parseTemplateOptions(template);
    return template;
  }

  parseTemplateOptions(template: ITemplate): ITemplate {
    const keys: Array<string> = Object.keys(template.options);
    const parsedOptions: Array<IOption> = [];
    keys.forEach((key: string) => {
      const option: IOption = template.options[key];
      if (option.type) {
        if (option.attributes) {
          if (option.attributes.hide) {
            if (option.attributes.hide.value === true) {
              return;
            }
          }
        }

        if (
          option.type === "select" ||
          (option.attributes.template && option.type === "input") ||
          (option.attributes.template && option.type === "text")
        ) {
          const obj: IOption = option;
          obj.key = key;
          parsedOptions.push(obj);
        }
      }
    });

    // eslint-disable-next-line camelcase
    template.parsed_options = parsedOptions;

    return template;
  }

  getOptionByCode(codeName: string): IOption {
    const template: ITemplate = this.getTemplate();
    let option: IOption = null;

    if (template) {
      if (template.options) {
        const optionsKeys: Array<string> = Object.keys(template.options);
        if (optionsKeys.length > 0) {
          optionsKeys.forEach((key: string) => {
            const opt: IOption = template.options[key];
            if (opt.code === codeName) {
              option = opt;
            }
          });
        }
      }
    }

    return option;
  }

  getOptionByTemplate(templateName: string): IOption {
    const template: ITemplate = this.getTemplate();
    let option: IOption = null;

    if (template) {
      if (template.options) {
        const optionsKeys: Array<string> = Object.keys(template.options);
        if (optionsKeys.length > 0) {
          optionsKeys.forEach((key: string) => {
            const opt: IOption = template.options[key];
            if (opt.attributes) {
              if (opt.attributes.template) {
                if (opt.attributes.template.value === templateName) {
                  option = opt;
                }
              }
            }
          });
        }
      }
    }

    return option;
  }

  getOptionValue(option: IOption, valueName: string): ILabelOptionValue {
    let result: any = null;
    if (option) {
      option.values.forEach((value: ILabelOptionValue) => {
        if (value.value === valueName) {
          result = value;
        }
      });
    }
    return result;
  }

  getOptionCodes(attr: string, value: any): string[] {
    const template: ITemplate = this.getTemplate();
    const optionCodes: string[] = [];

    if (template) {
      if (template.options) {
        const optionsKeys: Array<string> = Object.keys(template.options);
        if (optionsKeys.length > 0) {
          optionsKeys.forEach((key: string) => {
            const opt: IOption = template.options[key];
            if (
              opt.attributes &&
              opt.attributes[attr] &&
              opt.attributes[attr].value === value
            ) {
              optionCodes.push(opt.code);
            }
          });
        }
      }
    }

    return optionCodes;
  }

  getResetOptionCodes(): string[] {
    return this.getOptionCodes("reset-on-change", true);
  }

  getDontTriggerChangeOptionCodes(): string[] {
    return this.getOptionCodes("trigger-change", false);
  }
}
